import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Toast from './Toast';
import { removeNotification } from '../../store/slices/uiSlice';
const NotificationContainer = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.ui.notifications);
  
  const handleClose = (id) => {
    dispatch(removeNotification(id));
  };
  
  if (notifications.length === 0) {
    return null;
  }
  
  return (
    <div className="notification-container">
      {notifications.map((notification) => (
        <Toast
          key={notification.id}
          type={notification.type}
          message={notification.message}
          onClose={() => handleClose(notification.id)}
          duration={notification.duration || 5000}
        />
      ))}
    </div>
  );
};

export default NotificationContainer;